import React, { useState, Fragment, useEffect } from 'react';
import {
  Button, Card, Badge,
  Modal,
} from 'reactstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { NavLink } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faCheck, faTrashAlt, faEdit, } from '@fortawesome/free-solid-svg-icons';
import FormsType from '../../../../../../data/FormsType';
import Forms from './Forms';
import FormsContacts from './FormsContacts';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { deleteAPI_FormLanguageVersions_By_FormId, gAPI_FormLanguageVersion_ByFormAndLanguage, putAPI_Update_Forms } from '../../../../../../constants/APIs';

export function FormsList({
  item,
  propertyId,
  LoadData,
  languageCode,
  categoryList,
  service
}) {
  const [isEdit, setIsEdit] = useState(false);
  const [isContact, setIsContact] = useState(false);
  const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(false);
  const [isCopied, setIsCopied] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  useEffect(() => {
    setCheckedPrimarySmall(item.status === 'Active' ? true : false);
  }, [item]);

  useEffect(() => {
    const handleOnClick = () => {
      setIsCopied(false);
      document.removeEventListener('click', handleOnClick);
    };
    if (isCopied) {
      document.addEventListener('click', handleOnClick);
    }
  }, [isCopied]);

  function generateRandomColor() {
    var arr = [
      'primary',
      'secondary',
      'info',
      'success',
      'warning',
      'danger',
      'light',
      'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
  }
  const handleSwitchChange = (value) => {
    setCheckedPrimarySmall(value);
    handleOnOff(value);
  };
  const handleOnOff = (onoff) => {
    const body = {
      status: onoff === false ? 'Inactive' : 'Active',
      updator: 'dashboard',
    };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Forms}/${item.id}/status`,
      data: body,
    }).then((res) => {
      LoadData(languageCode);
    });
  };
  // Add below your other handlers
  const handleDelete = async () => {
    const body = {
      status: "Archieve",
      updator: "dashboard",
    };

    AxiosAPI({
      method: "put",
      url: `${putAPI_Update_Forms}/${item.id}/status`,
      data: body,
    }).then(() => {
      setShowDeleteModal(false);
      LoadData(languageCode);
    });
  };

  return (
    <Fragment>
      <Card className="d-flex flex-row mb-3">
        <div className="pl-2 d-flex flex-grow-1 min-width-zero">
          <Badge
            key={0}
            className={`position-absolute badge-top-left ${item.isGlobal ? 'badge-button-color' : 'badge-button-sec'}`}
            color={generateRandomColor()}
            pill
          >
            {item.isGlobal ? 'Global' : 'Property'}
          </Badge>
          <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
            <p className="mb-1 ml-5  text-small w-40 w-sm-100">
              <b>{item.name}</b> <br />({item.id})
            </p>
            <p className="mb-1 text-muted text-small w-20 w-sm-100">
              {FormsType.filter((i) => i.value.includes(item.formType)).map(
                (p) => p.label
              )}
            </p>
            <p className="mb-1 text-muted text-small w-15 w-sm-100">
              <NavLink
                style={{ textDecoration: 'underline' }}
                to={{
                  pathname: '/app/pages/agent-assist',
                  state: { categoryvalue: item.categories && item.categories.length > 0 ? item.categories[0] : "" },
                }}
              >
                {item.submissions} Submissions
              </NavLink>
            </p>
            <p className="mb-1 text-muted text-small w-10 w-sm-100">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small"
                checked={checkedPrimarySmall}
                onChange={(primary) => handleSwitchChange(primary)}
              />
            </p>
            {/* <div className="mb-1 w-10 w-sm-100">
              <Button
                color="primary"
                size="xs"
                onClick={() => setIsEdit(!isEdit)}
              >
                Edit
              </Button>
            </div> */}
            <div className="mb-1 w-15 w-sm-100">
              <Button
                color="secondary"
                size="xs"
                outline
                onClick={() => setIsContact(!isContact)}
              >
                + Add Notifications
              </Button>
            </div>
            <div className="mb-1 w-15 w-sm-100">
              <CopyToClipboard
                text={
                  (service !== null && service !== undefined && service !== ""
                    ? `https://chatapps.${service}`
                    : process.env.REACT_APP_BASE_CHATUI) +
                  '/form-view?id=' +
                  item.id +
                  '&gid=' +
                  getGroupID() +
                  '&pid=' +
                  propertyId +
                  ''
                }
                onCopy={() => {
                  setIsCopied(true);
                }}
              >
                <Button color="success" size="xs">
                  <FontAwesomeIcon icon={isCopied ? faCheck : faCopy} />{' '}
                  {isCopied ? 'Copied!' : 'Copy Link'}
                </Button>
              </CopyToClipboard>
            </div>
            <div className='d-flex mb-1 w-10 w-sm-100'>
              <FontAwesomeIcon className='mr-2' style={{ fontSize: '18px' }}
                icon={faEdit}
                color="#90caf9"
                cursor="pointer"
                title='Edit'
                onClick={() => setIsEdit(!isEdit)}
              />
              <Fragment>
                <b> | </b>
                <FontAwesomeIcon className='ml-2 ' style={{ fontSize: '18px', color: 'var(--theme-color-1)' }}
                  icon={faTrashAlt}
                  cursor="pointer"
                  title='Delete'
                  onClick={() => setShowDeleteModal(true)}
                />
              </Fragment>
            </div>
          </div>
        </div>
      </Card>
      {
        showDeleteModal &&
        <Modal isOpen={showDeleteModal} toggle={() => setShowDeleteModal(false)}>
          <div className="modal-header">
            <h5 className="modal-title">Confirm Delete</h5>
            <button
              type="button"
              className="close"
              onClick={() => setShowDeleteModal(false)}
            >
              <span>&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <p>
              Are you sure you want to delete this form?
              <br />
              <b>This action will permanently delete the form and it won't be visible anymore.</b>
              <br /><br />
              Please ensure this form is not being used.
            </p>
          </div>

          <div className="modal-footer">
            <Button color="secondary" onClick={() => setShowDeleteModal(false)}>
              Cancel
            </Button>

            <Button color="danger" onClick={handleDelete}>
              Yes, Delete
            </Button>
          </div>
        </Modal>
      }
      {isEdit && (
        <Forms
          visible={isEdit}
          toggle={() => setIsEdit(!isEdit)}
          formLabel={'Update'}
          LoadData={LoadData}
          id={item.id}
          languageCode={languageCode}
          categoryList={categoryList}
          service={service}
        ></Forms>
      )}
      {isContact && (
        <FormsContacts
          visible={isContact}
          sendMewsNotification={item.sendMewsNotification}
          type={item.formType}
          contacts={item.contacts}
          toggle={() => setIsContact(!isContact)}
          LoadData={LoadData}
          id={item.id}
          propertyId={propertyId}
          languageCode={languageCode}
        ></FormsContacts>
      )}
    </Fragment>
  );
}
